import { render, staticRenderFns } from "./import-transferencia.vue?vue&type=template&id=34fb0099"
import script from "./import-transferencia.vue?vue&type=script&lang=ts"
export * from "./import-transferencia.vue?vue&type=script&lang=ts"
import style0 from "./import-transferencia.vue?vue&type=style&index=0&id=34fb0099&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports